<template>
  <div
    class="intro"
    :class="'intro--theme-' + config.theme"
  >
    <ODFLayout
      :title="config.claim"
      :theme="config.theme"
      :blason="config.intro.blason"
      :pattern="config.intro.pattern"
    >
      <div class="intro__content">
        <div class="intro__centered">
          <div
            v-if="!config.available"
            class="intro__teaser"
          >
            <TeaserVideo
              :posterframe="config.intro.posterframe"
              :video="config.intro.video"
            />
          </div>

          <Viewer
            v-else
            :theme="config.theme"
            :material="coinMaterial"
            :normals="coinNormals"
            class="intro__viewer"
          />
        </div>

        <div class="intro__text txtbox">
          <h2 class="txtbox__title">
            {{ config.intro.title }}
          </h2>

          <p class="txtbox__detail">
            {{ config.intro.detail }}
          </p>

          <ButtonDefault
            class="txtbox__actions"
            :label="config.available ? $store.state.config.common.discoverButton : config.intro.button"
            :theme="config.theme"
            :arrow="config.available ? 'bottom' : 'top-right'"
            :to="config.available ? null : urlMuseum"
            negative
            @click.native="buttonClickHanlder"
          />
        </div>
      </div>

      <ButtonVideo
        v-if="buttonVideoConfig.available"
        slot="footer"
        v-bind="buttonVideoConfig.props"
        class="intro__footer"
      />
    </ODFLayout>
  </div>
</template>

<script>
import ODFLayout from '@/components/ODFLayout.vue';
import Viewer from '@/components/viewer/Viewer.vue';
import ButtonDefault from '@/components/buttons/ButtonDefault.vue';
import ButtonVideo from '@/components/buttons/ButtonVideo.vue';
import TeaserVideo from '@/components/teaser/TeaserVideo.vue';

export default {
  components: {
    ODFLayout,
    Viewer,
    TeaserVideo,
    ButtonDefault,
    ButtonVideo,
  },

  props: {
    config: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    urlMuseum() {
      return window.___museum;
    },

    coinData() {
      const coinAttribute = `___${this.$props.config.id}___coin`;
      const coinId = window[coinAttribute] || '1';
      const coinData = this.$props.config.products.find(p => p.id === coinId);
      return coinData || this.$props.config.products[0];
    },

    coinMaterial() {
      if (!this.coinData || !this.coinData.path) return null;
      return this.coinData.path.startsWith('/gold') ? 'gold' : 'silver';
    },

    coinNormals() {
      if (!this.coinData || !this.coinData.path) return null;
      return `${this.$store.state.staticAssetsPath}normalmaps/${this.$props.config.id}${this.coinData.path}.jpeg`;
    },

    buttonVideoConfig() {
      return this.$store.getters.getButtonVideoConfigByConfig(this.$props.config);
    },
  },

  methods: {
    buttonClickHanlder() {
      if (this.$props.config.available) {
        this.$emit('buttonClick');
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
centered-content() {
  @media (min-width: 1730px) {
    { block }
  }
}
.intro {
  prevent-user-select();
  width: 100%;
  height: 100%;
}

.intro__content {
  +above('l') {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
  }
}

.intro__centered {
  position: relative;
  z-index: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  padding-bottom: 100%;
  width: 100%;
  height: 0;

  +above('l') {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    padding: 0;
    height: 100%;
    justify-content: flex-end;
  }

  +centered-content() {
    justify-content: center;
  }
}

.intro__teaser,
.intro__viewer {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  width: 100%;
  height: @width;

  +above('l') {
    position: static;
    flex-shrink: 0;
    width: round(364px * 1.1);
    height: @width;
  }

  +above('xl') {
    width: round(486px * 1.1);
    height: @width;
  }

  +above('xxl') {
    width: round(576px * 1.1);
    height: @width;
  }

  +centered-content() {
    margin-left: 80px;
    .tabnav__item:first-child & {
      margin-left: 160px;
    }
  }
}

.intro__text {
  position: relative;
  z-index: 1;

  +above('l') { max-width: 296px; }
  +above('xl') { max-width: 300px; }
  +above('xxl') {
    max-width: 430px;
    .tabnav__item:first-child & {
      max-width: 460px;
    }
  }
}

.txtbox {
  color: $cl-white;

  &__title {
    @extend $typo-landing-title;
    text-transform: uppercase;
    color: $cl-gold;
    margin: 20px 0;

    .intro--theme-orange & {
      color: $cl-white;
    }
  }

  &__detail {
    @extend $typo-landing-normal;
    margin: 20px 0;

    +desktop() { max-width: 380px; }
  }

  &__actions {
    margin: 20px 0;

    +desktop() { display: inline-block; }
  }
}
</style>
